import React, { useState } from 'react'
import { LoyaltyArticle } from '../../../../interfaces/loyality.interface';
import { Restaurant } from '../../../../interfaces/Catalogue';
import { LoyaltyArticleCard } from './LoyaltyArticleCard/LoyaltyArticleCard';
import { LoyaltyRedemptionModal } from '../../../shared/Modals/LoyaltyRedemptionModal/LoyaltyRedemptionModal';
import { GenericCardList } from '../../../common/GenericCardList/GenericCardList';
import { useConfig } from '../../../../context/ConfigContext';
import './LoyaltyArticlesList.scss';

interface LoyaltyArticlesListProps {
  rewards: LoyaltyArticle[];
  itemsPerRow?: 1 | 2 | 3 | 4;
  containerPadding?: number;
  itemSpacing?: number;
  scrollDirection?: 'vertical' | 'horizontal';
  restaurant: Restaurant;
  onPressViewAll?: () => void;
}

export const LoyaltyArticlesList: React.FC<LoyaltyArticlesListProps> = ({
  rewards,
  itemsPerRow = 2,
  containerPadding = 4,
  itemSpacing = 12,
  scrollDirection = 'vertical',
  restaurant,
  onPressViewAll
}) => {
  const { config } = useConfig();
  const primaryColor = config?.primaryColor || '#6366F1';
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState<LoyaltyArticle | null>(null);

  const handleItemPress = (item: LoyaltyArticle) => {
    setSelectedItem(item);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedItem(null);
  };

  const renderLoyaltyCard = (item: LoyaltyArticle, onPress?: (item: LoyaltyArticle) => void) => (
    <LoyaltyArticleCard
      item={item}
      onPress={() => onPress?.(item)}
      itemsPerRow={itemsPerRow}
      containerPadding={containerPadding}
      itemSpacing={itemSpacing}
    />
  );

  const handleViewAllPress = () => {
    onPressViewAll?.();
  }



  return (
    <div className="loyalty-articles-list">
      <GenericCardList
        data={rewards}
        renderCard={renderLoyaltyCard}
        onCardPress={handleItemPress}
        keyExtractor={(item) => item.id}
        scrollDirection={scrollDirection}
        containerPadding={4}
        itemSpacing={35}
        showHorizontalScrollIndicator={false}

        contentContainerStyle={{ paddingBottom: 4 }}
        showViewAll={true}
        onPressViewAll={handleViewAllPress}
        itemsPerRow={itemsPerRow}
      />

      <LoyaltyRedemptionModal
        visible={modalVisible}
        item={selectedItem}
        restaurant={restaurant}
        onClose={closeModal}
        onRedeem={(item) => {
          console.log('Redeem item:', item);
          closeModal();
        }}
      />
    </div>
  );
};